import { render, staticRenderFns } from "./table-tr.vue?vue&type=template&id=76378915&"
import script from "./table-tr.vue?vue&type=script&lang=js&"
export * from "./table-tr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../rubis-bi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports